/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ ((module) => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/**
 * Menu Categories Custom Element
 * Handles tabbed navigation for menu categories in the mobile drawer
 */
var MenuCategories = /*#__PURE__*/function (_HTMLElement) {
  _inherits(MenuCategories, _HTMLElement);
  var _super = _createSuper(MenuCategories);
  function MenuCategories() {
    var _this;
    _classCallCheck(this, MenuCategories);
    _this = _super.call(this);

    // Get all category buttons and content panels
    _this.categoryButtons = _this.querySelectorAll('.menu-category-button');
    _this.categoryContents = _this.querySelectorAll('.menu-category-content');

    // Initialize the component
    _this.init();
    return _this;
  }

  /**
   * Initialize the menu categories functionality
   */
  _createClass(MenuCategories, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      if (this.categoryButtons.length === 0 || this.categoryContents.length === 0) {
        return;
      }

      // Add click event listeners to each category button
      this.categoryButtons.forEach(function (button, index) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.activateCategory(index);
        });

        // Add keyboard support
        button.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            _this2.activateCategory(index);
          }
          // Arrow key navigation
          else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            _this2.navigateWithArrows(event.key, index);
          }
        });
      });

      // Set initial active state (first category should be active)
      this.activateCategory(0);
    }

    /**
     * Activate a specific category tab
     * @param {number} index - Index of the category to activate
     */
  }, {
    key: "activateCategory",
    value: function activateCategory(index) {
      if (index < 0 || index >= this.categoryButtons.length) {
        return;
      }

      // Remove active state from all buttons and contents
      this.categoryButtons.forEach(function (button, i) {
        button.classList.remove('is-active');
        button.setAttribute('aria-selected', 'false');
        button.setAttribute('tabindex', '-1');
      });
      this.categoryContents.forEach(function (content, i) {
        content.classList.remove('is-active');
        content.setAttribute('hidden', '');
      });

      // Add active state to selected button and content
      var activeButton = this.categoryButtons[index];
      var activeContent = this.categoryContents[index];
      if (activeButton && activeContent) {
        activeButton.classList.add('is-active');
        activeButton.setAttribute('aria-selected', 'true');
        activeButton.setAttribute('tabindex', '0');
        activeContent.classList.add('is-active');
        activeContent.removeAttribute('hidden');
      }

      // Store current active index
      this.activeIndex = index;
    }

    /**
     * Handle arrow key navigation
     * @param {string} key - The key that was pressed
     * @param {number} currentIndex - Current active index
     */
  }, {
    key: "navigateWithArrows",
    value: function navigateWithArrows(key, currentIndex) {
      var newIndex;
      if (key === 'ArrowRight') {
        newIndex = (currentIndex + 1) % this.categoryButtons.length;
      } else if (key === 'ArrowLeft') {
        newIndex = (currentIndex - 1 + this.categoryButtons.length) % this.categoryButtons.length;
      }
      if (newIndex !== undefined) {
        this.activateCategory(newIndex);
        this.categoryButtons[newIndex].focus();
      }
    }

    /**
     * Get the currently active category index
     * @returns {number} Active category index
     */
  }, {
    key: "getActiveIndex",
    value: function getActiveIndex() {
      return this.activeIndex || 0;
    }

    /**
     * Get the currently active category button
     * @returns {HTMLElement|null} Active category button element
     */
  }, {
    key: "getActiveButton",
    value: function getActiveButton() {
      return this.categoryButtons[this.getActiveIndex()] || null;
    }

    /**
     * Get the currently active category content
     * @returns {HTMLElement|null} Active category content element
     */
  }, {
    key: "getActiveContent",
    value: function getActiveContent() {
      return this.categoryContents[this.getActiveIndex()] || null;
    }
  }]);
  return MenuCategories;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element
if (!customElements.get('menu-categories')) {
  customElements.define('menu-categories', MenuCategories);
}

/**
 * Free Shipping Message Custom Element
 * Dynamically shows/hides free shipping message based on variant price
 */
var FreeShippingMessage = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(FreeShippingMessage, _HTMLElement2);
  var _super2 = _createSuper(FreeShippingMessage);
  function FreeShippingMessage() {
    var _this3;
    _classCallCheck(this, FreeShippingMessage);
    _this3 = _super2.call(this);

    // Get minimum price threshold from data attribute (in cents)
    _this3.threshold = parseInt(_this3.dataset.threshold) * Shopify.currency.rate;
    _this3.productPrice = parseInt(_this3.dataset.productPrice);
    if (_this3.productPrice != null && _this3.productPrice >= _this3.threshold) {
      _this3.classList.add('qualified');
      _this3.setAttribute('aria-hidden', 'false');
    }

    // Listen for variant change events
    document.addEventListener('productVariantChanged', _this3.handleVariantChange.bind(_assertThisInitialized(_this3)));
    return _this3;
  }

  /**
   * Handle variant change events
   * @param {CustomEvent} event - The variant changed event
   */
  _createClass(FreeShippingMessage, [{
    key: "handleVariantChange",
    value: function handleVariantChange(event) {
      var _event$detail = event.detail,
        variant = _event$detail.variant,
        available = _event$detail.available;
      if (!variant) {
        this.classList.remove('qualified');
        return;
      }

      // Get variant price (in cents)
      var variantPrice = variant.price;

      // Update visibility based on price
      this.updateVisibility(variantPrice);
    }
  }, {
    key: "updateVisibility",
    value: function updateVisibility(currentPrice) {
      // Check if price qualifies for free shipping
      if (currentPrice >= this.minimumPrice) {
        this.classList.add('qualified');
      } else {
        this.classList.remove('qualified');
      }
    }
  }]);
  return FreeShippingMessage;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the free shipping message custom element
if (!customElements.get('free-shipping-message')) {
  customElements.define('free-shipping-message', FreeShippingMessage);
}
var FreeShippingBadge = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(FreeShippingBadge, _HTMLElement3);
  var _super3 = _createSuper(FreeShippingBadge);
  function FreeShippingBadge() {
    var _this4;
    _classCallCheck(this, FreeShippingBadge);
    _this4 = _super3.call(this);
    _this4.threshold = parseInt(_this4.dataset.threshold) * Shopify.currency.rate;
    _this4.productPrice = parseInt(_this4.dataset.productPrice);
    if (_this4.productPrice != null && _this4.productPrice >= _this4.threshold) {
      _this4.style.display = 'block';
      _this4.setAttribute('aria-hidden', 'false');
    }
    return _this4;
  }
  return _createClass(FreeShippingBadge);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('free-shipping-badge')) {
  customElements.define('free-shipping-badge', FreeShippingBadge);
}
var FreeGiftsBanner = /*#__PURE__*/function (_HTMLElement4) {
  _inherits(FreeGiftsBanner, _HTMLElement4);
  var _super4 = _createSuper(FreeGiftsBanner);
  function FreeGiftsBanner() {
    var _this5;
    _classCallCheck(this, FreeGiftsBanner);
    _this5 = _super4.call(this);
    _this5.freeGifts = _this5.querySelectorAll('[data-threshold]');
    _this5.productPrice = parseInt(_this5.dataset.productPrice);
    _this5.displayFreeGiftsBanner = false;
    if (_this5.productPrice != null) {
      _this5.freeGifts.forEach(function (gift) {
        var threshold = parseInt(gift.dataset.threshold) * Shopify.currency.rate;
        if (threshold != null && _this5.productPrice >= threshold) {
          gift.style.display = 'flex';
          _this5.displayFreeGiftsBanner = true;
        } else {
          gift.style.display = 'none';
        }
      });
    }
    if (_this5.displayFreeGiftsBanner) {
      _this5.style.display = 'block';
    }
    return _this5;
  }
  return _createClass(FreeGiftsBanner);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('free-gifts-banner')) {
  customElements.define('free-gifts-banner', FreeGiftsBanner);
}

/**
 * Desktop Columns Selector Custom Element
 * Handles switching between different column layouts (2, 3, 6 columns) on the product grid
 */
var DesktopColumnsSelector = /*#__PURE__*/function (_HTMLElement5) {
  _inherits(DesktopColumnsSelector, _HTMLElement5);
  var _super5 = _createSuper(DesktopColumnsSelector);
  function DesktopColumnsSelector() {
    var _this6;
    _classCallCheck(this, DesktopColumnsSelector);
    _this6 = _super5.call(this);

    // Get all column selector buttons
    _this6.buttons = _this6.querySelectorAll('.columns-selector__button');
    _this6.productGrid = document.getElementById('product-grid');

    // Initialize the component
    _this6.init();
    return _this6;
  }

  /**
   * Initialize the columns selector functionality
   */
  _createClass(DesktopColumnsSelector, [{
    key: "init",
    value: function init() {
      var _this7 = this;
      if (this.buttons.length === 0 || !this.productGrid) {
        return;
      }

      // Add click event listeners to each button
      this.buttons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var columns = button.getAttribute('data-columns');
          _this7.setColumns(columns);
        });

        // Add keyboard support
        button.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            var columns = button.getAttribute('data-columns');
            _this7.setColumns(columns);
          }
        });
      });
    }

    /**
     * Set the number of columns for the product grid
     * @param {string} columns - Number of columns (2, 3, or 6)
     */
  }, {
    key: "setColumns",
    value: function setColumns(columns) {
      // Get fresh reference to product grid (it may have been replaced by facets update)
      var productGrid = document.getElementById('product-grid');
      if (!columns || !productGrid) {
        return;
      }

      // Check if productGrid has a child with grid product-grid classes
      var gridElement = productGrid.querySelector('.grid.product-grid') || productGrid;

      // Remove all existing column classes
      gridElement.classList.remove('grid--2-col-desktop', 'grid--3-col-desktop', 'grid--4-col-desktop', 'grid--5-col-desktop', 'grid--6-col-desktop');

      // Add the new column class
      gridElement.classList.add("grid--".concat(columns, "-col-desktop"));

      // Update button states
      this.buttons.forEach(function (button) {
        button.classList.remove('selected-option');
        button.setAttribute('aria-pressed', 'false');
      });

      // Set active state on clicked button
      var activeButton = Array.from(this.buttons).find(function (btn) {
        return btn.getAttribute('data-columns') === columns;
      });
      if (activeButton) {
        activeButton.classList.add('selected-option');
        activeButton.setAttribute('aria-pressed', 'true');
      }

      // Store preference in localStorage
      try {
        localStorage.setItem('preferredColumns', columns);
      } catch (e) {
        // Fail silently if localStorage is not available
        console.warn('Could not save column preference:', e);
      }

      // Dispatch custom event for other components that might need to react
      this.dispatchEvent(new CustomEvent('columnsChanged', {
        detail: {
          columns: columns
        },
        bubbles: true
      }));
    }

    /**
     * Load saved column preference from localStorage
     */
  }, {
    key: "loadPreference",
    value: function loadPreference() {
      try {
        var savedColumns = localStorage.getItem('preferredColumns');
        if (savedColumns) {
          this.setColumns(savedColumns);
        }
      } catch (e) {
        // Fail silently if localStorage is not available
        console.warn('Could not load column preference:', e);
      }
    }

    /**
     * Called when element is added to the DOM
     */
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      // Load saved preference when component is ready
      this.loadPreference();
    }
  }]);
  return DesktopColumnsSelector;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the desktop columns selector custom element
if (!customElements.get('desktop-columns-selector')) {
  customElements.define('desktop-columns-selector', DesktopColumnsSelector);
}

/**
 * Product Media Selector Custom Element
 * Handles switching between product images and model images view
 */
var ProductMediaSelector = /*#__PURE__*/function (_HTMLElement6) {
  _inherits(ProductMediaSelector, _HTMLElement6);
  var _super6 = _createSuper(ProductMediaSelector);
  function ProductMediaSelector() {
    var _this8;
    _classCallCheck(this, ProductMediaSelector);
    _this8 = _super6.call(this);

    // Get all media selector buttons
    _this8.buttons = _this8.querySelectorAll('.media-selector__button');
    _this8.productGrid = document.getElementById('product-grid');

    // Initialize the component
    _this8.init();
    return _this8;
  }

  /**
   * Initialize the media selector functionality
   */
  _createClass(ProductMediaSelector, [{
    key: "init",
    value: function init() {
      var _this9 = this;
      if (this.buttons.length === 0 || !this.productGrid) {
        return;
      }

      // Add click event listeners to each button
      this.buttons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var mediaType = button.getAttribute('data-media-type');
          _this9.setMediaType(mediaType);
        });

        // Add keyboard support
        button.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            var mediaType = button.getAttribute('data-media-type');
            _this9.setMediaType(mediaType);
          }
        });
      });
    }

    /**
     * Set the media type for the product grid
     * @param {string} mediaType - Media type ('product' or 'model')
     */
  }, {
    key: "setMediaType",
    value: function setMediaType(mediaType) {
      // Get fresh reference to product grid (it may have been replaced by facets update)
      var productGrid = document.getElementById('product-grid');
      if (!mediaType || !productGrid) {
        return;
      }

      // Check if productGrid has a child with grid product-grid classes
      var gridElement = productGrid.querySelector('.grid.product-grid') || productGrid;

      // Remove all existing media type classes
      gridElement.classList.remove('product-option-selected', 'model-option-selected');

      // Add the new media type class
      gridElement.classList.add("".concat(mediaType, "-option-selected"));

      // Update button states
      this.buttons.forEach(function (button) {
        button.classList.remove('selected-option');
        button.setAttribute('aria-pressed', 'false');
      });

      // Set active state on clicked button
      var activeButton = Array.from(this.buttons).find(function (btn) {
        return btn.getAttribute('data-media-type') === mediaType;
      });
      if (activeButton) {
        activeButton.classList.add('selected-option');
        activeButton.setAttribute('aria-pressed', 'true');
      }

      // Store preference in localStorage
      try {
        localStorage.setItem('preferredMediaType', mediaType);
      } catch (e) {
        // Fail silently if localStorage is not available
        console.warn('Could not save media type preference:', e);
      }

      // Dispatch custom event for other components that might need to react
      this.dispatchEvent(new CustomEvent('mediaTypeChanged', {
        detail: {
          mediaType: mediaType
        },
        bubbles: true
      }));
    }

    /**
     * Load saved media type preference from localStorage
     */
  }, {
    key: "loadPreference",
    value: function loadPreference() {
      try {
        var savedMediaType = localStorage.getItem('preferredMediaType');
        if (savedMediaType) {
          this.setMediaType(savedMediaType);
        }
      } catch (e) {
        // Fail silently if localStorage is not available
        console.warn('Could not load media type preference:', e);
      }
    }

    /**
     * Called when element is added to the DOM
     */
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      // Load saved preference when component is ready
      this.loadPreference();
    }
  }]);
  return ProductMediaSelector;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the product media selector custom element
if (!customElements.get('product-media-selector')) {
  customElements.define('product-media-selector', ProductMediaSelector);
}

/**
 * Mobile Columns Selector Custom Element
 * Handles switching between 1 and 2 column layouts on mobile/tablet
 */
var MobileColumnsSelector = /*#__PURE__*/function (_HTMLElement7) {
  _inherits(MobileColumnsSelector, _HTMLElement7);
  var _super7 = _createSuper(MobileColumnsSelector);
  function MobileColumnsSelector() {
    var _this10;
    _classCallCheck(this, MobileColumnsSelector);
    _this10 = _super7.call(this);

    // Get all column selector buttons
    _this10.buttons = _this10.querySelectorAll('.columns-selector__button');

    // Initialize the component
    _this10.init();
    return _this10;
  }

  /**
   * Initialize the columns selector functionality
   */
  _createClass(MobileColumnsSelector, [{
    key: "init",
    value: function init() {
      var _this11 = this;
      if (this.buttons.length === 0) {
        return;
      }

      // Add click event listeners to each button
      this.buttons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var columns = button.getAttribute('data-columns');
          _this11.setColumns(columns);
        });

        // Add keyboard support
        button.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            var columns = button.getAttribute('data-columns');
            _this11.setColumns(columns);
          }
        });
      });
    }

    /**
     * Set the number of columns for mobile grid
     * @param {string} columns - Number of columns (1 or 2)
     */
  }, {
    key: "setColumns",
    value: function setColumns(columns) {
      // Get fresh reference to product grid (it may have been replaced by facets update)
      var productGrid = document.getElementById('product-grid');
      if (!columns || !productGrid) {
        return;
      }

      // Check if productGrid has a child with grid product-grid classes
      var gridElement = productGrid.querySelector('.grid.product-grid') || productGrid;

      // Remove all existing mobile column classes
      gridElement.classList.remove('grid--1-col-tablet-down', 'grid--2-col-tablet-down');

      // Add the new column class
      gridElement.classList.add("grid--".concat(columns, "-col-tablet-down"));

      // Update button states
      this.buttons.forEach(function (button) {
        button.classList.remove('selected-option');
        button.setAttribute('aria-pressed', 'false');
      });

      // Set active state on clicked button
      var activeButton = Array.from(this.buttons).find(function (btn) {
        return btn.getAttribute('data-columns') === columns;
      });
      if (activeButton) {
        activeButton.classList.add('selected-option');
        activeButton.setAttribute('aria-pressed', 'true');
      }

      // Store preference in localStorage
      try {
        localStorage.setItem('preferredMobileColumns', columns);
      } catch (e) {
        // Fail silently if localStorage is not available
        console.warn('Could not save mobile column preference:', e);
      }

      // Dispatch custom event for other components that might need to react
      this.dispatchEvent(new CustomEvent('mobileColumnsChanged', {
        detail: {
          columns: columns
        },
        bubbles: true
      }));
    }

    /**
     * Load saved column preference from localStorage
     */
  }, {
    key: "loadPreference",
    value: function loadPreference() {
      try {
        var savedColumns = localStorage.getItem('preferredMobileColumns');
        if (savedColumns) {
          this.setColumns(savedColumns);
        }
      } catch (e) {
        // Fail silently if localStorage is not available
        console.warn('Could not load mobile column preference:', e);
      }
    }

    /**
     * Called when element is added to the DOM
     */
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      // Load saved preference when component is ready
      this.loadPreference();
    }
  }]);
  return MobileColumnsSelector;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the mobile columns selector custom element
// Register the mobile columns selector custom element
if (!customElements.get('mobile-columns-selector')) {
  customElements.define('mobile-columns-selector', MobileColumnsSelector);
}

/**
 * Link Bar Filter Selector Custom Element
 * Handles filter application when clicking link-bar filter items
 */
var LinkBarFilterSelector = /*#__PURE__*/function (_HTMLElement8) {
  _inherits(LinkBarFilterSelector, _HTMLElement8);
  var _super8 = _createSuper(LinkBarFilterSelector);
  function LinkBarFilterSelector() {
    var _this12;
    _classCallCheck(this, LinkBarFilterSelector);
    _this12 = _super8.call(this);
    _this12.addEventListener('click', function (event) {
      var filterItem = event.target.closest('.link-bar__filter-item');
      if (filterItem) {
        event.preventDefault();
        var filterKey = filterItem.dataset.filterKey;
        var filterValue = filterItem.dataset.filterValue;
        if (filterKey && filterValue) {
          window.dispatchEvent(new CustomEvent('facets:applyFilter', {
            detail: {
              filterName: filterKey,
              filterValue: filterValue
            }
          }));
        }
      }
    });
    return _this12;
  }
  return _createClass(LinkBarFilterSelector);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the link bar filter selector custom element
if (!customElements.get('link-bar-filter-selector')) {
  customElements.define('link-bar-filter-selector', LinkBarFilterSelector);
}

/**
 * Reinitialize selectors after facets/filters are updated
 */
document.addEventListener('facets:updated', function () {
  // Reinitialize desktop columns selector
  var columnsSelector = document.querySelector('desktop-columns-selector');
  if (columnsSelector) {
    columnsSelector.loadPreference();
  }

  // Reinitialize mobile columns selector
  var mobileColumnsSelector = document.querySelector('mobile-columns-selector');
  if (mobileColumnsSelector) {
    mobileColumnsSelector.loadPreference();
  }

  // Reinitialize product media selector
  var mediaSelector = document.querySelector('product-media-selector');
  if (mediaSelector) {
    mediaSelector.loadPreference();
  }
});

/**
 * Size Chart Drawer Custom Element
 * Handles the size chart drawer functionality
 */
var SizeChartDrawer = /*#__PURE__*/function (_HTMLElement9) {
  _inherits(SizeChartDrawer, _HTMLElement9);
  var _super9 = _createSuper(SizeChartDrawer);
  function SizeChartDrawer() {
    var _this13;
    _classCallCheck(this, SizeChartDrawer);
    _this13 = _super9.call(this);
    _this13.addEventListener('keyup', function (evt) {
      return evt.code === 'Escape' && _this13.close();
    });
    _this13.querySelector('#SizeChartDrawer-Overlay').addEventListener('click', _this13.close.bind(_assertThisInitialized(_this13)));

    // Initialize elements
    _this13.elements = {
      chartContent: _this13.querySelector('.size-chart-drawer__chart-content')
    };

    // Set up event listeners
    _this13.setupEventListeners();
    return _this13;
  }
  _createClass(SizeChartDrawer, [{
    key: "setupEventListeners",
    value: function setupEventListeners() {
      // Add any additional event listeners here
    }
  }, {
    key: "open",
    value: function open() {
      var _this14 = this;
      this.openedBy = document.activeElement;
      this.setAttribute('open', '');
      if (this.classList.contains('animate')) {
        this.addEventListener('transitionend', function () {
          var containerToTrapFocusOn = _this14.querySelector('.drawer__inner');
          var focusElement = _this14.querySelector('.drawer__close');
          _this14.trapFocus(containerToTrapFocusOn, focusElement);
        }, {
          once: true
        });
      }
      document.body.classList.add('overflow-hidden');
    }
  }, {
    key: "close",
    value: function close() {
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      if (this.openedBy) {
        this.removeTrapFocus(this.openedBy);
        this.openedBy = null;
      }
    }
  }, {
    key: "show",
    value: function show(productHandle) {
      // Product-specific logic can be added here
      this.productHandle = productHandle;
      this.open();

      // Initialize ring size chart when drawer opens
      this.initializeRingSizeChart();
    }
  }, {
    key: "initializeRingSizeChart",
    value: function initializeRingSizeChart() {
      var _this15 = this;
      // Wait a bit for the drawer to be fully visible
      setTimeout(function () {
        var chartContainer = _this15.querySelector('#ring-size-chart-container');
        if (chartContainer && window.RingSizeChart && !_this15.ringSizeChart) {
          _this15.ringSizeChart = new window.RingSizeChart(chartContainer);

          // Listen for size selection events
          chartContainer.addEventListener('sizeSelected', function (event) {
            console.log('Size selected:', event.detail);
            // You can add custom logic here when a size is selected
          });
        }
      }, 100);
    }

    // Focus trap functionality
  }, {
    key: "trapFocus",
    value: function trapFocus(container) {
      var _this16 = this;
      var elementToFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : container;
      var elements = this.getFocusableElements(container);
      var first = elements[0];
      var last = elements[elements.length - 1];
      this.removeTrapFocus();
      this.trapFocusHandlers = this.trapFocusHandlers || {};
      this.trapFocusHandlers.focusin = function (event) {
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener('keydown', _this16.trapFocusHandlers.keydown);
      };
      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', _this16.trapFocusHandlers.keydown);
      };
      this.trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key

        // If tab key is pressed
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }

        //  If shift + tab keys are pressed
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          last.focus();
        }
      };
      document.addEventListener('focusout', this.trapFocusHandlers.focusout);
      document.addEventListener('focusin', this.trapFocusHandlers.focusin);
      elementToFocus.focus();
    }

    // Try to remove the trap focus
  }, {
    key: "removeTrapFocus",
    value: function removeTrapFocus() {
      var elementToFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (this.trapFocusHandlers) {
        document.removeEventListener('focusin', this.trapFocusHandlers.focusin);
        document.removeEventListener('focusout', this.trapFocusHandlers.focusout);
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown);
      }
      if (elementToFocus) elementToFocus.focus();
    }

    // Find all focusable elements inside a container
  }, {
    key: "getFocusableElements",
    value: function getFocusableElements(container) {
      return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
    }
  }]);
  return SizeChartDrawer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the size chart drawer custom element
if (!customElements.get('size-chart-drawer')) {
  customElements.define('size-chart-drawer', SizeChartDrawer);
}

/**
 * Size Chart Tabs Custom Element
 * Handles the tabbed navigation within the size chart drawer
 */
var SizeChartTabs = /*#__PURE__*/function (_HTMLElement10) {
  _inherits(SizeChartTabs, _HTMLElement10);
  var _super10 = _createSuper(SizeChartTabs);
  function SizeChartTabs() {
    var _this17;
    _classCallCheck(this, SizeChartTabs);
    _this17 = _super10.call(this);

    // Get all tab buttons and panels
    _this17.tabButtons = _this17.querySelectorAll('.size-chart-tabs__button');
    _this17.tabPanels = _this17.querySelectorAll('.size-chart-tabs__panel');

    // Initialize the component
    _this17.init();
    return _this17;
  }

  /**
   * Initialize the tabs functionality
   */
  _createClass(SizeChartTabs, [{
    key: "init",
    value: function init() {
      var _this18 = this;
      if (this.tabButtons.length === 0 || this.tabPanels.length === 0) {
        return;
      }

      // Add click event listeners to each tab button
      this.tabButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var tabId = button.getAttribute('data-tab');
          _this18.activateTab(tabId);
        });

        // Add keyboard support
        button.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            var tabId = button.getAttribute('data-tab');
            _this18.activateTab(tabId);
          }
          // Arrow key navigation
          else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            _this18.navigateWithArrows(event.key, button);
          }
        });
      });

      // Set initial active state (first tab should be active)
      var firstTab = this.tabButtons[0];
      if (firstTab) {
        var firstTabId = firstTab.getAttribute('data-tab');
        this.activateTab(firstTabId);
      }
    }

    /**
     * Activate a specific tab
     * @param {string} tabId - The ID of the tab to activate
     */
  }, {
    key: "activateTab",
    value: function activateTab(tabId) {
      // Remove active state from all buttons and panels
      this.tabButtons.forEach(function (button) {
        button.classList.remove('size-chart-tabs__button--active');
        button.setAttribute('aria-selected', 'false');
      });
      this.tabPanels.forEach(function (panel) {
        panel.classList.remove('size-chart-tabs__panel--active');
        panel.setAttribute('hidden', '');
      });

      // Add active state to selected button and panel
      var activeButton = this.querySelector("[data-tab=\"".concat(tabId, "\"]"));
      var activePanel = this.querySelector("[data-panel=\"".concat(tabId, "\"]"));
      if (activeButton) {
        activeButton.classList.add('size-chart-tabs__button--active');
        activeButton.setAttribute('aria-selected', 'true');
      }
      if (activePanel) {
        activePanel.classList.add('size-chart-tabs__panel--active');
        activePanel.removeAttribute('hidden');
      }

      // Store current active tab
      this.activeTabId = tabId;
    }

    /**
     * Handle arrow key navigation
     * @param {string} key - The key that was pressed
     * @param {HTMLElement} currentButton - Current focused button
     */
  }, {
    key: "navigateWithArrows",
    value: function navigateWithArrows(key, currentButton) {
      var buttonArray = Array.from(this.tabButtons);
      var currentIndex = buttonArray.indexOf(currentButton);
      var newIndex;
      if (key === 'ArrowRight') {
        newIndex = (currentIndex + 1) % buttonArray.length;
      } else if (key === 'ArrowLeft') {
        newIndex = (currentIndex - 1 + buttonArray.length) % buttonArray.length;
      }
      if (newIndex !== undefined && buttonArray[newIndex]) {
        var newButton = buttonArray[newIndex];
        var newTabId = newButton.getAttribute('data-tab');
        this.activateTab(newTabId);
        newButton.focus();
      }
    }

    /**
     * Get the currently active tab ID
     * @returns {string} Active tab ID
     */
  }, {
    key: "getActiveTabId",
    value: function getActiveTabId() {
      return this.activeTabId || 'chart';
    }
  }]);
  return SizeChartTabs;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the size chart tabs custom element
if (!customElements.get('size-chart-tabs')) {
  customElements.define('size-chart-tabs', SizeChartTabs);
}

// Measuring Guide Tabs Component
var MeasuringGuideTabs = /*#__PURE__*/function (_HTMLElement11) {
  _inherits(MeasuringGuideTabs, _HTMLElement11);
  var _super11 = _createSuper(MeasuringGuideTabs);
  function MeasuringGuideTabs() {
    var _this19;
    _classCallCheck(this, MeasuringGuideTabs);
    _this19 = _super11.call(this);
    _this19.currentTab = 'measure-finger';
    return _this19;
  }
  _createClass(MeasuringGuideTabs, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.setupEventListeners();
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this20 = this;
      // Tab button click handlers
      var tabButtons = this.querySelectorAll('[data-measuring-tab]');
      tabButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          var tabId = e.target.getAttribute('data-measuring-tab');
          _this20.switchTab(tabId);
        });

        // Keyboard navigation
        button.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            var tabId = e.target.getAttribute('data-measuring-tab');
            _this20.switchTab(tabId);
          }

          // Arrow key navigation
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            e.preventDefault();
            var buttons = Array.from(_this20.querySelectorAll('[data-measuring-tab]'));
            var currentIndex = buttons.indexOf(e.target);
            var nextIndex;
            if (e.key === 'ArrowLeft') {
              nextIndex = currentIndex > 0 ? currentIndex - 1 : buttons.length - 1;
            } else {
              nextIndex = currentIndex < buttons.length - 1 ? currentIndex + 1 : 0;
            }
            buttons[nextIndex].focus();
            var nextTabId = buttons[nextIndex].getAttribute('data-measuring-tab');
            _this20.switchTab(nextTabId);
          }
        });
      });
    }
  }, {
    key: "switchTab",
    value: function switchTab(tabId) {
      if (tabId === this.currentTab) return;

      // Update current tab
      this.currentTab = tabId;

      // Update button states
      var buttons = this.querySelectorAll('[data-measuring-tab]');
      buttons.forEach(function (btn) {
        btn.classList.remove('measuring-guide-tabs__button--active');
        btn.setAttribute('aria-selected', 'false');
        btn.setAttribute('tabindex', '-1');
        if (btn.getAttribute('data-measuring-tab') === tabId) {
          btn.classList.add('measuring-guide-tabs__button--active');
          btn.setAttribute('aria-selected', 'true');
          btn.setAttribute('tabindex', '0');
        }
      });

      // Update panel states
      var panels = this.querySelectorAll('[data-measuring-panel]');
      panels.forEach(function (panel) {
        panel.classList.remove('measuring-guide-tabs__panel--active');
        panel.setAttribute('aria-hidden', 'true');
        if (panel.getAttribute('data-measuring-panel') === tabId) {
          panel.classList.add('measuring-guide-tabs__panel--active');
          panel.setAttribute('aria-hidden', 'false');
        }
      });

      // Emit custom event
      this.dispatchEvent(new CustomEvent('measuringTabChanged', {
        detail: {
          activeTab: tabId,
          element: this
        },
        bubbles: true
      }));
    }

    // Public method to switch to a specific tab
  }, {
    key: "setActiveTab",
    value: function setActiveTab(tabId) {
      this.switchTab(tabId);
    }

    // Public method to get current active tab
  }, {
    key: "getActiveTab",
    value: function getActiveTab() {
      return this.currentTab;
    }
  }]);
  return MeasuringGuideTabs;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the measuring guide tabs component
customElements.define('measuring-guide-tabs', MeasuringGuideTabs);

/**
 * Bracelet Size Chart Drawer Custom Element
 * Handles the bracelet size chart drawer functionality
 */
var BraceletSizeChartDrawer = /*#__PURE__*/function (_HTMLElement12) {
  _inherits(BraceletSizeChartDrawer, _HTMLElement12);
  var _super12 = _createSuper(BraceletSizeChartDrawer);
  function BraceletSizeChartDrawer() {
    var _this21;
    _classCallCheck(this, BraceletSizeChartDrawer);
    _this21 = _super12.call(this);
    _this21.addEventListener('keyup', function (evt) {
      return evt.code === 'Escape' && _this21.close();
    });
    _this21.querySelector('#BraceletSizeChartDrawer-Overlay').addEventListener('click', _this21.close.bind(_assertThisInitialized(_this21)));

    // Initialize elements
    _this21.elements = {
      chartContent: _this21.querySelector('.bracelet-size-chart-drawer__chart-content')
    };

    // Set up event listeners
    _this21.setupEventListeners();
    return _this21;
  }
  _createClass(BraceletSizeChartDrawer, [{
    key: "setupEventListeners",
    value: function setupEventListeners() {
      // Add any additional event listeners here
    }
  }, {
    key: "open",
    value: function open() {
      var _this22 = this;
      this.openedBy = document.activeElement;
      this.setAttribute('open', '');
      if (this.classList.contains('animate')) {
        this.addEventListener('transitionend', function () {
          var containerToTrapFocusOn = _this22.querySelector('.drawer__inner');
          var focusElement = _this22.querySelector('.drawer__close');
          _this22.trapFocus(containerToTrapFocusOn, focusElement);
        }, {
          once: true
        });
      }
      document.body.classList.add('overflow-hidden');
    }
  }, {
    key: "close",
    value: function close() {
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      if (this.openedBy) {
        this.removeTrapFocus(this.openedBy);
        this.openedBy = null;
      }
    }
  }, {
    key: "show",
    value: function show(productHandle) {
      // Product-specific logic can be added here
      this.productHandle = productHandle;
      this.open();

      // Initialize bracelet size chart when drawer opens
      this.initializeBraceletSizeChart();
    }
  }, {
    key: "initializeBraceletSizeChart",
    value: function initializeBraceletSizeChart() {
      var _this23 = this;
      // Wait a bit for the drawer to be fully visible
      setTimeout(function () {
        var chartContainer = _this23.querySelector('#bracelet-size-chart-container');
        if (chartContainer && window.BraceletSizeChart && !_this23.braceletSizeChart) {
          _this23.braceletSizeChart = new window.BraceletSizeChart(chartContainer);

          // Listen for size selection events
          chartContainer.addEventListener('sizeSelected', function (event) {
            console.log('Bracelet size selected:', event.detail);
            // You can add custom logic here when a size is selected
          });
        }
      }, 100);
    }

    // Focus trap functionality (same as SizeChartDrawer)
  }, {
    key: "trapFocus",
    value: function trapFocus(container) {
      var _this24 = this;
      var elementToFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : container;
      var elements = this.getFocusableElements(container);
      var first = elements[0];
      var last = elements[elements.length - 1];
      this.removeTrapFocus();
      this.trapFocusHandlers = this.trapFocusHandlers || {};
      this.trapFocusHandlers.focusin = function (event) {
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener('keydown', _this24.trapFocusHandlers.keydown);
      };
      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', _this24.trapFocusHandlers.keydown);
      };
      this.trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key

        // If tab key is pressed
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }

        //  If shift + tab keys are pressed
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          last.focus();
        }
      };
      document.addEventListener('focusout', this.trapFocusHandlers.focusout);
      document.addEventListener('focusin', this.trapFocusHandlers.focusin);
      elementToFocus.focus();
    }

    // Try to remove the trap focus
  }, {
    key: "removeTrapFocus",
    value: function removeTrapFocus() {
      var elementToFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (this.trapFocusHandlers) {
        document.removeEventListener('focusin', this.trapFocusHandlers.focusin);
        document.removeEventListener('focusout', this.trapFocusHandlers.focusout);
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown);
      }
      if (elementToFocus) elementToFocus.focus();
    }

    // Find all focusable elements inside a container
  }, {
    key: "getFocusableElements",
    value: function getFocusableElements(container) {
      return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
    }
  }]);
  return BraceletSizeChartDrawer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the bracelet size chart drawer custom element
if (!customElements.get('bracelet-size-chart-drawer')) {
  customElements.define('bracelet-size-chart-drawer', BraceletSizeChartDrawer);
}

/**
 * Bracelet Size Chart Tabs Custom Element
 * Handles the tabbed navigation within the bracelet size chart drawer
 */
var BraceletSizeChartTabs = /*#__PURE__*/function (_HTMLElement13) {
  _inherits(BraceletSizeChartTabs, _HTMLElement13);
  var _super13 = _createSuper(BraceletSizeChartTabs);
  function BraceletSizeChartTabs() {
    var _this25;
    _classCallCheck(this, BraceletSizeChartTabs);
    _this25 = _super13.call(this);

    // Get all tab buttons and panels
    _this25.tabButtons = _this25.querySelectorAll('.size-chart-tabs__button');
    _this25.tabPanels = _this25.querySelectorAll('.size-chart-tabs__panel');

    // Initialize the component
    _this25.init();
    return _this25;
  }

  /**
   * Initialize the tabs functionality
   */
  _createClass(BraceletSizeChartTabs, [{
    key: "init",
    value: function init() {
      var _this26 = this;
      if (this.tabButtons.length === 0 || this.tabPanels.length === 0) {
        return;
      }

      // Add click event listeners to each tab button
      this.tabButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var tabId = button.getAttribute('data-tab');
          _this26.activateTab(tabId);
        });

        // Add keyboard support
        button.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            var tabId = button.getAttribute('data-tab');
            _this26.activateTab(tabId);
          }
          // Arrow key navigation
          else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            _this26.navigateWithArrows(event.key, button);
          }
        });
      });

      // Set initial active state (first tab should be active)
      var firstTab = this.tabButtons[0];
      if (firstTab) {
        var firstTabId = firstTab.getAttribute('data-tab');
        this.activateTab(firstTabId);
      }
    }

    /**
     * Activate a specific tab
     * @param {string} tabId - The ID of the tab to activate
     */
  }, {
    key: "activateTab",
    value: function activateTab(tabId) {
      // Remove active state from all buttons and panels
      this.tabButtons.forEach(function (button) {
        button.classList.remove('size-chart-tabs__button--active');
        button.setAttribute('aria-selected', 'false');
      });
      this.tabPanels.forEach(function (panel) {
        panel.classList.remove('size-chart-tabs__panel--active');
        panel.setAttribute('hidden', '');
      });

      // Add active state to selected button and panel
      var activeButton = this.querySelector("[data-tab=\"".concat(tabId, "\"]"));
      var activePanel = this.querySelector("[data-panel=\"".concat(tabId, "\"]"));
      if (activeButton) {
        activeButton.classList.add('size-chart-tabs__button--active');
        activeButton.setAttribute('aria-selected', 'true');
      }
      if (activePanel) {
        activePanel.classList.add('size-chart-tabs__panel--active');
        activePanel.removeAttribute('hidden');
      }

      // Store current active tab
      this.activeTabId = tabId;
    }

    /**
     * Handle arrow key navigation
     * @param {string} key - The key that was pressed
     * @param {HTMLElement} currentButton - Current focused button
     */
  }, {
    key: "navigateWithArrows",
    value: function navigateWithArrows(key, currentButton) {
      var currentIndex = Array.from(this.tabButtons).indexOf(currentButton);
      var newIndex;
      if (key === 'ArrowRight') {
        newIndex = (currentIndex + 1) % this.tabButtons.length;
      } else if (key === 'ArrowLeft') {
        newIndex = (currentIndex - 1 + this.tabButtons.length) % this.tabButtons.length;
      }
      if (newIndex !== undefined) {
        var newButton = this.tabButtons[newIndex];
        newButton.focus();
        var tabId = newButton.getAttribute('data-tab');
        this.activateTab(tabId);
      }
    }

    /**
     * Get the currently active tab ID
     * @returns {string} Active tab ID
     */
  }, {
    key: "getActiveTabId",
    value: function getActiveTabId() {
      var _this$tabButtons$;
      return this.activeTabId || ((_this$tabButtons$ = this.tabButtons[0]) === null || _this$tabButtons$ === void 0 ? void 0 : _this$tabButtons$.getAttribute('data-tab')) || '';
    }
  }]);
  return BraceletSizeChartTabs;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the bracelet size chart tabs custom element
if (!customElements.get('bracelet-size-chart-tabs')) {
  customElements.define('bracelet-size-chart-tabs', BraceletSizeChartTabs);
}

/**
 * Bracelet Measuring Guide Tabs Custom Element
 * Handles the tabbed navigation within the bracelet measuring guide panel
 */
var BraceletMeasuringGuideTabs = /*#__PURE__*/function (_HTMLElement14) {
  _inherits(BraceletMeasuringGuideTabs, _HTMLElement14);
  var _super14 = _createSuper(BraceletMeasuringGuideTabs);
  function BraceletMeasuringGuideTabs() {
    var _this27;
    _classCallCheck(this, BraceletMeasuringGuideTabs);
    _this27 = _super14.call(this);

    // Get all tab buttons and panels
    _this27.tabButtons = _this27.querySelectorAll('.measuring-guide-tabs__button');
    _this27.tabPanels = _this27.querySelectorAll('.measuring-guide-tabs__panel');

    // Initialize the component
    _this27.init();
    return _this27;
  }

  /**
   * Initialize the tabs functionality
   */
  _createClass(BraceletMeasuringGuideTabs, [{
    key: "init",
    value: function init() {
      var _this28 = this;
      if (this.tabButtons.length === 0 || this.tabPanels.length === 0) {
        return;
      }

      // Add click event listeners to each tab button
      this.tabButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var tabId = button.getAttribute('data-measuring-tab');
          _this28.activateTab(tabId);
        });

        // Add keyboard support
        button.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            var tabId = button.getAttribute('data-measuring-tab');
            _this28.activateTab(tabId);
          }
          // Arrow key navigation
          else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            _this28.navigateWithArrows(event.key, button);
          }
        });
      });

      // Set initial active state (first tab should be active)
      var firstTab = this.tabButtons[0];
      if (firstTab) {
        var firstTabId = firstTab.getAttribute('data-measuring-tab');
        this.activateTab(firstTabId);
      }
    }

    /**
     * Activate a specific tab
     * @param {string} tabId - The ID of the tab to activate
     */
  }, {
    key: "activateTab",
    value: function activateTab(tabId) {
      // Remove active state from all buttons and panels
      this.tabButtons.forEach(function (button) {
        button.classList.remove('measuring-guide-tabs__button--active');
        button.setAttribute('aria-selected', 'false');
      });
      this.tabPanels.forEach(function (panel) {
        panel.classList.remove('measuring-guide-tabs__panel--active');
        panel.setAttribute('hidden', '');
      });

      // Add active state to selected button and panel
      var activeButton = this.querySelector("[data-measuring-tab=\"".concat(tabId, "\"]"));
      var activePanel = this.querySelector("[data-measuring-panel=\"".concat(tabId, "\"]"));
      if (activeButton) {
        activeButton.classList.add('measuring-guide-tabs__button--active');
        activeButton.setAttribute('aria-selected', 'true');
      }
      if (activePanel) {
        activePanel.classList.add('measuring-guide-tabs__panel--active');
        activePanel.removeAttribute('hidden');
      }

      // Store current active tab
      this.activeTabId = tabId;
    }

    /**
     * Handle arrow key navigation
     * @param {string} key - The key that was pressed
     * @param {HTMLElement} currentButton - Current focused button
     */
  }, {
    key: "navigateWithArrows",
    value: function navigateWithArrows(key, currentButton) {
      var currentIndex = Array.from(this.tabButtons).indexOf(currentButton);
      var newIndex;
      if (key === 'ArrowRight') {
        newIndex = (currentIndex + 1) % this.tabButtons.length;
      } else if (key === 'ArrowLeft') {
        newIndex = (currentIndex - 1 + this.tabButtons.length) % this.tabButtons.length;
      }
      if (newIndex !== undefined) {
        var newButton = this.tabButtons[newIndex];
        newButton.focus();
        var tabId = newButton.getAttribute('data-measuring-tab');
        this.activateTab(tabId);
      }
    }

    /**
     * Get the currently active tab ID
     * @returns {string} Active tab ID
     */
  }, {
    key: "getActiveTabId",
    value: function getActiveTabId() {
      var _this$tabButtons$2;
      return this.activeTabId || ((_this$tabButtons$2 = this.tabButtons[0]) === null || _this$tabButtons$2 === void 0 ? void 0 : _this$tabButtons$2.getAttribute('data-measuring-tab')) || '';
    }
  }]);
  return BraceletMeasuringGuideTabs;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the bracelet measuring guide tabs custom element
if (!customElements.get('bracelet-measuring-guide-tabs')) {
  customElements.define('bracelet-measuring-guide-tabs', BraceletMeasuringGuideTabs);
}

/**
 * Bracelet Size Chart Manager
 * Handles interactions for the bracelet size chart including unit switching
 */
var BraceletSizeChart = /*#__PURE__*/function () {
  function BraceletSizeChart(container) {
    _classCallCheck(this, BraceletSizeChart);
    this.container = container.closest('.size-chart-chart-content');
    this.currentRegion = 'US';
    this.currentUnit = 'cm';
    this.init();
  }
  _createClass(BraceletSizeChart, [{
    key: "init",
    value: function init() {
      this.setupEventListeners();
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this29 = this;
      // Unit toggle buttons
      var unitButtons = this.container.querySelectorAll('[data-unit]');
      unitButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          var unit = e.target.getAttribute('data-unit');
          if (unit !== _this29.currentUnit) {
            _this29.currentUnit = unit;
            _this29.updateUnits();
          }
        });
      });

      // Region selector (if needed in the future)
      var regionSelect = this.container.querySelector('[data-region-select]');
      if (regionSelect) {
        regionSelect.addEventListener('change', function (e) {
          _this29.currentRegion = e.target.value;
          _this29.updateRegion();
        });
      }
    }
  }, {
    key: "updateUnits",
    value: function updateUnits() {
      var _this30 = this;
      // Update unit toggle buttons
      var unitButtons = this.container.querySelectorAll('[data-unit]');
      unitButtons.forEach(function (btn) {
        btn.classList.remove('active');
        if (btn.getAttribute('data-unit') === _this30.currentUnit) {
          btn.classList.add('active');
        }
      });

      // Update all measurement displays with ranges and units
      var measurements = this.container.querySelectorAll('.size-chart-measurement');
      measurements.forEach(function (measurement) {
        var cmRange = measurement.getAttribute('data-cm-range');
        var inchRange = measurement.getAttribute('data-inch-range');
        var rangeSpan = measurement.querySelector('.measurement-range');
        var unitSpan = measurement.querySelector('.measurement-unit');
        if (rangeSpan && unitSpan) {
          if (_this30.currentUnit === 'cm') {
            rangeSpan.textContent = cmRange;
            unitSpan.textContent = 'cm';
          } else {
            rangeSpan.textContent = inchRange;
            unitSpan.textContent = 'inch';
          }
        }
      });
    }
  }, {
    key: "updateRegion",
    value: function updateRegion() {
      // Update region label
      var regionLabel = this.container.querySelector('[data-current-region]');
      if (regionLabel) {
        regionLabel.textContent = this.currentRegion;
      }

      // Hide all rows
      var allRows = this.container.querySelectorAll('.size-chart-row');
      allRows.forEach(function (row) {
        row.style.display = 'none';
      });

      // Show rows for current region
      var currentRegionRows = this.container.querySelectorAll("[data-region=\"".concat(this.currentRegion, "\"]"));
      currentRegionRows.forEach(function (row) {
        row.style.display = 'flex';
      });
    }
  }]);
  return BraceletSizeChart;
}(); // Export for use in other files
if (typeof window !== 'undefined') {
  window.BraceletSizeChart = BraceletSizeChart;
}

// Helper function to open size chart drawer from anywhere
window.openSizeChartDrawer = function (triggerElement, productHandle) {
  var drawer = document.querySelector('#SizeChartDrawer');
  if (drawer) {
    drawer.show(productHandle || '');
  }
};

/**
 * Chain Size Chart Manager
 * Handles interactions for the chain size chart including unit switching
 */
var ChainSizeChart = /*#__PURE__*/function () {
  function ChainSizeChart(container) {
    _classCallCheck(this, ChainSizeChart);
    this.container = container;
    this.currentUnit = 'cm';
    this.init();
  }
  _createClass(ChainSizeChart, [{
    key: "init",
    value: function init() {
      this.setupEventListeners();
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this31 = this;
      // Unit toggle buttons
      var unitButtons = this.container.querySelectorAll('[data-unit]');
      unitButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          var unit = e.target.getAttribute('data-unit');
          if (unit !== _this31.currentUnit) {
            _this31.currentUnit = unit;
            _this31.updateUnits();
          }
        });
      });
    }
  }, {
    key: "updateUnits",
    value: function updateUnits() {
      var _this32 = this;
      // Update unit toggle buttons
      var unitButtons = this.container.querySelectorAll('[data-unit]');
      unitButtons.forEach(function (btn) {
        btn.classList.remove('active');
        if (btn.getAttribute('data-unit') === _this32.currentUnit) {
          btn.classList.add('active');
        }
      });

      // Update all measurement displays with ranges and units
      var measurements = this.container.querySelectorAll('.size-chart-measurement');
      measurements.forEach(function (measurement) {
        var cmRange = measurement.getAttribute('data-cm-range');
        var inchRange = measurement.getAttribute('data-inch-range');
        var rangeSpan = measurement.querySelector('.measurement-range');
        var unitSpan = measurement.querySelector('.measurement-unit');
        if (rangeSpan && unitSpan) {
          if (_this32.currentUnit === 'cm') {
            rangeSpan.textContent = cmRange;
            unitSpan.textContent = 'cm';
          } else {
            rangeSpan.textContent = inchRange;
            unitSpan.textContent = 'inch';
          }
        }
      });
    }
  }]);
  return ChainSizeChart;
}(); // Export for use in other files
if (typeof window !== 'undefined') {
  window.ChainSizeChart = ChainSizeChart;
}

/**
 * Chain Size Chart Drawer Custom Element
 * Handles the chain size chart drawer functionality
 */
var ChainSizeChartDrawer = /*#__PURE__*/function (_HTMLElement15) {
  _inherits(ChainSizeChartDrawer, _HTMLElement15);
  var _super15 = _createSuper(ChainSizeChartDrawer);
  function ChainSizeChartDrawer() {
    var _this33;
    _classCallCheck(this, ChainSizeChartDrawer);
    _this33 = _super15.call(this);
    _this33.addEventListener('keyup', function (evt) {
      return evt.code === 'Escape' && _this33.close();
    });
    _this33.querySelector('#ChainSizeChartDrawer-Overlay').addEventListener('click', _this33.close.bind(_assertThisInitialized(_this33)));

    // Initialize elements
    _this33.elements = {
      chartContent: _this33.querySelector('.chain-size-chart-drawer__chart-content')
    };

    // Set up event listeners
    _this33.setupEventListeners();
    return _this33;
  }
  _createClass(ChainSizeChartDrawer, [{
    key: "setupEventListeners",
    value: function setupEventListeners() {
      // Add any additional event listeners here
    }
  }, {
    key: "open",
    value: function open() {
      var _this34 = this;
      this.openedBy = document.activeElement;
      this.setAttribute('open', '');
      if (this.classList.contains('animate')) {
        this.addEventListener('transitionend', function () {
          _this34.trapFocus(_this34.querySelector('.drawer__inner'));
        }, {
          once: true
        });
      }
      document.body.classList.add('overflow-hidden');
    }
  }, {
    key: "close",
    value: function close() {
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      if (this.openedBy) {
        this.removeTrapFocus(this.openedBy);
        this.openedBy = null;
      }
    }
  }, {
    key: "show",
    value: function show(productHandle) {
      // Product-specific logic can be added here
      this.productHandle = productHandle;
      this.open();

      // Initialize chain size chart when drawer opens
      this.initializeChainSizeChart();
    }
  }, {
    key: "initializeChainSizeChart",
    value: function initializeChainSizeChart() {
      var _this35 = this;
      // Wait a bit for the drawer to be fully visible
      setTimeout(function () {
        var chartContainer = _this35.querySelector('#chain-size-chart-container');
        if (chartContainer && window.ChainSizeChart && !_this35.chainSizeChart) {
          _this35.chainSizeChart = new window.ChainSizeChart(chartContainer);

          // Listen for size selection events
          chartContainer.addEventListener('sizeSelected', function (event) {
            console.log('Chain size selected:', event.detail);
            // You can add custom logic here when a size is selected
          });
        }
      }, 100);
    }

    // Focus trap functionality (same as other drawers)
  }, {
    key: "trapFocus",
    value: function trapFocus(container) {
      var _this36 = this;
      var elementToFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : container;
      var elements = this.getFocusableElements(container);
      var first = elements[0];
      var last = elements[elements.length - 1];
      this.removeTrapFocus();
      this.trapFocusHandlers = this.trapFocusHandlers || {};
      this.trapFocusHandlers.focusin = function (event) {
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener('keydown', _this36.trapFocusHandlers.keydown);
      };
      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', _this36.trapFocusHandlers.keydown);
      };
      this.trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key

        // If tab key is pressed
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }

        //  If shift + tab keys are pressed
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          last.focus();
        }
      };
      document.addEventListener('focusout', this.trapFocusHandlers.focusout);
      document.addEventListener('focusin', this.trapFocusHandlers.focusin);
      elementToFocus.focus();
    }

    // Try to remove the trap focus
  }, {
    key: "removeTrapFocus",
    value: function removeTrapFocus() {
      var elementToFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (this.trapFocusHandlers) {
        document.removeEventListener('focusin', this.trapFocusHandlers.focusin);
        document.removeEventListener('focusout', this.trapFocusHandlers.focusout);
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown);
      }
      if (elementToFocus) elementToFocus.focus();
    }

    // Find all focusable elements inside a container
  }, {
    key: "getFocusableElements",
    value: function getFocusableElements(container) {
      return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
    }
  }]);
  return ChainSizeChartDrawer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the chain size chart drawer custom element
if (!customElements.get('chain-size-chart-drawer')) {
  customElements.define('chain-size-chart-drawer', ChainSizeChartDrawer);
}

/**
 * Chain Size Chart Tabs Custom Element
 * Handles the tabbed navigation within the chain size chart drawer
 */
var ChainSizeChartTabs = /*#__PURE__*/function (_HTMLElement16) {
  _inherits(ChainSizeChartTabs, _HTMLElement16);
  var _super16 = _createSuper(ChainSizeChartTabs);
  function ChainSizeChartTabs() {
    var _this37;
    _classCallCheck(this, ChainSizeChartTabs);
    _this37 = _super16.call(this);

    // Get all tab buttons and panels
    _this37.tabButtons = _this37.querySelectorAll('.size-chart-tabs__button');
    _this37.tabPanels = _this37.querySelectorAll('.size-chart-tabs__panel');

    // Initialize the component
    _this37.init();
    return _this37;
  }

  /**
   * Initialize the tabs functionality
   */
  _createClass(ChainSizeChartTabs, [{
    key: "init",
    value: function init() {
      var _this38 = this;
      if (this.tabButtons.length === 0 || this.tabPanels.length === 0) {
        return;
      }

      // Add click event listeners to each tab button
      this.tabButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var tabId = button.getAttribute('data-tab');
          _this38.activateTab(tabId);
        });

        // Add keyboard support
        button.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            _this38.navigateWithArrows(event.key, button);
          } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            var tabId = button.getAttribute('data-tab');
            _this38.activateTab(tabId);
          }
        });
      });

      // Set initial active state (first tab should be active)
      var firstTab = this.tabButtons[0];
      if (firstTab) {
        var firstTabId = firstTab.getAttribute('data-tab');
        this.activateTab(firstTabId);
      }
    }

    /**
     * Activate a specific tab
     * @param {string} tabId - The ID of the tab to activate
     */
  }, {
    key: "activateTab",
    value: function activateTab(tabId) {
      // Remove active state from all buttons and panels
      this.tabButtons.forEach(function (button) {
        button.classList.remove('size-chart-tabs__button--active');
        button.setAttribute('aria-selected', 'false');
      });
      this.tabPanels.forEach(function (panel) {
        panel.classList.remove('size-chart-tabs__panel--active');
        panel.setAttribute('hidden', '');
      });

      // Add active state to selected button and panel
      var activeButton = this.querySelector("[data-tab=\"".concat(tabId, "\"]"));
      var activePanel = this.querySelector("[data-panel=\"".concat(tabId, "\"]"));
      if (activeButton) {
        activeButton.classList.add('size-chart-tabs__button--active');
        activeButton.setAttribute('aria-selected', 'true');
      }
      if (activePanel) {
        activePanel.classList.add('size-chart-tabs__panel--active');
        activePanel.removeAttribute('hidden');
      }

      // Store current active tab
      this.activeTabId = tabId;
    }

    /**
     * Handle arrow key navigation
     * @param {string} key - The key that was pressed
     * @param {HTMLElement} currentButton - Current focused button
     */
  }, {
    key: "navigateWithArrows",
    value: function navigateWithArrows(key, currentButton) {
      var currentIndex = Array.from(this.tabButtons).indexOf(currentButton);
      var newIndex;
      if (key === 'ArrowRight') {
        newIndex = (currentIndex + 1) % this.tabButtons.length;
      } else if (key === 'ArrowLeft') {
        newIndex = (currentIndex - 1 + this.tabButtons.length) % this.tabButtons.length;
      }
      if (newIndex !== undefined) {
        var newButton = this.tabButtons[newIndex];
        var newTabId = newButton.getAttribute('data-tab');
        this.activateTab(newTabId);
        newButton.focus();
      }
    }

    /**
     * Get the currently active tab ID
     * @returns {string} Active tab ID
     */
  }, {
    key: "getActiveTabId",
    value: function getActiveTabId() {
      var _this$tabButtons$3;
      return this.activeTabId || ((_this$tabButtons$3 = this.tabButtons[0]) === null || _this$tabButtons$3 === void 0 ? void 0 : _this$tabButtons$3.getAttribute('data-tab')) || '';
    }
  }]);
  return ChainSizeChartTabs;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the chain size chart tabs custom element
if (!customElements.get('chain-size-chart-tabs')) {
  customElements.define('chain-size-chart-tabs', ChainSizeChartTabs);
}

/**
 * Chain Length Selector Custom Element
 * Handles chain length selection and unit toggling (cm/inch)
 */
var ChainLengthSelector = /*#__PURE__*/function (_HTMLElement17) {
  _inherits(ChainLengthSelector, _HTMLElement17);
  var _super17 = _createSuper(ChainLengthSelector);
  function ChainLengthSelector() {
    var _this39;
    _classCallCheck(this, ChainLengthSelector);
    _this39 = _super17.call(this);
    _this39.currentUnit = 'inch'; // Default to inches
    return _this39;
  }
  _createClass(ChainLengthSelector, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
    }
  }, {
    key: "init",
    value: function init() {
      this.setupEventListeners();
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this40 = this;
      // Unit toggle buttons
      var unitButtons = this.querySelectorAll('.size-chart-unit-btn');
      unitButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var unit = button.getAttribute('data-unit');
          _this40.switchUnit(unit);
        });
      });

      // Length buttons
      var lengthButtons = this.querySelectorAll('[data-length]');
      lengthButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          return _this40.selectLength(button);
        });
      });
    }
  }, {
    key: "switchUnit",
    value: function switchUnit(unit) {
      if (this.currentUnit === unit) return;
      this.currentUnit = unit;

      // Update active state on unit buttons
      var unitButtons = this.querySelectorAll('.size-chart-unit-btn');
      unitButtons.forEach(function (btn) {
        if (btn.getAttribute('data-unit') === unit) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });

      // Update button labels
      this.updateButtonLabels();
    }
  }, {
    key: "updateButtonLabels",
    value: function updateButtonLabels() {
      var _this41 = this;
      var buttons = this.querySelectorAll('[data-length]');
      buttons.forEach(function (button) {
        var cmValue = button.getAttribute('data-length');
        var inchValue = button.getAttribute('data-length-inch');
        if (_this41.currentUnit === 'cm') {
          button.textContent = cmValue;
        } else {
          button.textContent = inchValue + '"';
        }
      });
    }
  }, {
    key: "selectLength",
    value: function selectLength(selectedButton) {
      // Remove active class from all buttons
      var buttons = this.querySelectorAll('[data-length]');
      buttons.forEach(function (btn) {
        btn.classList.remove('measuring-guide-tabs__button--active');
        btn.setAttribute('aria-selected', 'false');
      });

      // Add active class to selected button
      selectedButton.classList.add('measuring-guide-tabs__button--active');
      selectedButton.setAttribute('aria-selected', 'true');

      // Update banner images based on selected length
      this.updateBannerImages();

      // Trigger custom event for other components to listen to
      var lengthCm = selectedButton.getAttribute('data-length');
      var lengthInch = selectedButton.getAttribute('data-length-inch');
      this.dispatchEvent(new CustomEvent('lengthchange', {
        detail: {
          cm: lengthCm,
          inch: lengthInch
        },
        bubbles: true
      }));
    }
  }, {
    key: "updateBannerImages",
    value: function updateBannerImages() {
      // Get current selected length
      var selectedLength = this.getSelectedLength();
      if (!selectedLength) return;
      var lengthInch = selectedLength.inch;

      // Get current active category from chain-category-tabs if it exists
      var parentTabs = this.closest('chain-size-chart-tabs');
      if (!parentTabs) return;
      var categoryTabs = parentTabs.querySelector('chain-category-tabs');
      var activeCategory = 'average'; // default
      if (categoryTabs) {
        activeCategory = categoryTabs.getActiveTabId() || 'average';
      }

      // Update banner images
      var bannerImages = parentTabs.querySelectorAll('.size-chart-tabs__banner-img');
      bannerImages.forEach(function (img) {
        var imgLength = img.getAttribute('data-length');
        var imgCategory = img.getAttribute('data-category');
        if (imgLength === lengthInch && imgCategory === activeCategory) {
          img.classList.remove('hidden');
        } else {
          img.classList.add('hidden');
        }
      });
    }

    // Public method to get current selected length
  }, {
    key: "getSelectedLength",
    value: function getSelectedLength() {
      var activeButton = this.querySelector('.measuring-guide-tabs__button--active');
      if (activeButton) {
        return {
          cm: activeButton.getAttribute('data-length'),
          inch: activeButton.getAttribute('data-length-inch')
        };
      }
      return null;
    }

    // Public method to get current unit
  }, {
    key: "getCurrentUnit",
    value: function getCurrentUnit() {
      return this.currentUnit;
    }
  }]);
  return ChainLengthSelector;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the chain length selector custom element
if (!customElements.get('chain-length-selector')) {
  customElements.define('chain-length-selector', ChainLengthSelector);
}

/**
 * Chain Category Tabs Custom Element
 * Handles the tabbed navigation for chain categories (Thin, Average, Broad)
 */
var ChainCategoryTabs = /*#__PURE__*/function (_HTMLElement18) {
  _inherits(ChainCategoryTabs, _HTMLElement18);
  var _super18 = _createSuper(ChainCategoryTabs);
  function ChainCategoryTabs() {
    var _this42;
    _classCallCheck(this, ChainCategoryTabs);
    _this42 = _super18.call(this);

    // Get all tab buttons
    _this42.tabButtons = _this42.querySelectorAll('.measuring-guide-tabs__button');

    // Initialize the component
    _this42.init();
    return _this42;
  }

  /**
   * Initialize the tabs functionality
   */
  _createClass(ChainCategoryTabs, [{
    key: "init",
    value: function init() {
      var _this43 = this;
      if (this.tabButtons.length === 0) {
        return;
      }

      // Add click event listeners to each tab button
      this.tabButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var tabId = button.getAttribute('data-measuring-tab');
          _this43.activateTab(tabId);
        });

        // Add keyboard support
        button.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            _this43.navigateWithArrows(event.key, button);
          } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            var tabId = button.getAttribute('data-measuring-tab');
            _this43.activateTab(tabId);
          }
        });
      });

      // Set initial active state (first tab should be active)
      var firstTab = this.tabButtons[0];
      if (firstTab) {
        var firstTabId = firstTab.getAttribute('data-measuring-tab');
        this.activateTab(firstTabId);
      }
    }

    /**
     * Activate a specific tab (only for banner switching, no panel switching)
     * @param {string} tabId - The ID of the tab to activate
     */
  }, {
    key: "activateTab",
    value: function activateTab(tabId) {
      // Remove active state from all buttons
      this.tabButtons.forEach(function (button) {
        button.classList.remove('measuring-guide-tabs__button--active');
        button.setAttribute('aria-selected', 'false');
      });

      // Add active state to selected button
      var activeButton = this.querySelector("[data-measuring-tab=\"".concat(tabId, "\"]"));
      if (activeButton) {
        activeButton.classList.add('measuring-guide-tabs__button--active');
        activeButton.setAttribute('aria-selected', 'true');
      }

      // Update the category heading text
      this.updateCategoryHeading(tabId);

      // Toggle banner images
      this.toggleBannerImages(tabId);

      // Store current active tab
      this.activeTabId = tabId;
    }

    /**
     * Toggle banner images based on active category AND selected length
     * @param {string} categoryId - The category ID (average, broad)
     */
  }, {
    key: "toggleBannerImages",
    value: function toggleBannerImages(categoryId) {
      // Find all banner images - check both chain-size-chart-tabs and pendant-size-chart-tabs contexts
      var parentElement = this.closest('chain-size-chart-tabs');
      if (!parentElement) {
        parentElement = this.closest('pendant-size-chart-tabs');
      }
      if (!parentElement) return;

      // Get current selected length from chain-length-selector
      var lengthSelector = parentElement.querySelector('chain-length-selector');
      var selectedLength = '18'; // default
      if (lengthSelector) {
        var length = lengthSelector.getSelectedLength();
        if (length) {
          selectedLength = length.inch;
        }
      }
      var bannerImages = parentElement.querySelectorAll('.size-chart-tabs__banner-img');
      bannerImages.forEach(function (img) {
        var imgCategory = img.getAttribute('data-category');
        var imgLength = img.getAttribute('data-length');

        // Skip images without required attributes
        if (!imgCategory || !imgLength) return;

        // Show image if both length and category match
        if (imgCategory === categoryId && imgLength === selectedLength) {
          img.classList.remove('hidden');
        } else {
          img.classList.add('hidden');
        }
      });
    }

    /**
     * Update the category heading text
     * @param {string} categoryId - The category ID (average, broad)
     */
  }, {
    key: "updateCategoryHeading",
    value: function updateCategoryHeading(categoryId) {
      var headingElement = this.querySelector('[data-active-category]');
      if (headingElement) {
        // Capitalize first letter of category ID
        var categoryName = categoryId.charAt(0).toUpperCase() + categoryId.slice(1);
        headingElement.textContent = categoryName;
      }
    }

    /**
     * Handle arrow key navigation
     * @param {string} key - The key that was pressed
     * @param {HTMLElement} currentButton - Current focused button
     */
  }, {
    key: "navigateWithArrows",
    value: function navigateWithArrows(key, currentButton) {
      var currentIndex = Array.from(this.tabButtons).indexOf(currentButton);
      var newIndex;
      if (key === 'ArrowRight') {
        newIndex = (currentIndex + 1) % this.tabButtons.length;
      } else if (key === 'ArrowLeft') {
        newIndex = (currentIndex - 1 + this.tabButtons.length) % this.tabButtons.length;
      }
      if (newIndex !== undefined) {
        var newButton = this.tabButtons[newIndex];
        var newTabId = newButton.getAttribute('data-measuring-tab');
        this.activateTab(newTabId);
        newButton.focus();
      }
    }

    /**
     * Get the currently active tab ID
     * @returns {string} Active tab ID
     */
  }, {
    key: "getActiveTabId",
    value: function getActiveTabId() {
      var _this$tabButtons$4;
      return this.activeTabId || ((_this$tabButtons$4 = this.tabButtons[0]) === null || _this$tabButtons$4 === void 0 ? void 0 : _this$tabButtons$4.getAttribute('data-measuring-tab')) || '';
    }
  }]);
  return ChainCategoryTabs;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the chain category tabs custom element
if (!customElements.get('chain-category-tabs')) {
  customElements.define('chain-category-tabs', ChainCategoryTabs);
}
var PendantCategoryTabs = /*#__PURE__*/function (_HTMLElement19) {
  _inherits(PendantCategoryTabs, _HTMLElement19);
  var _super19 = _createSuper(PendantCategoryTabs);
  function PendantCategoryTabs() {
    var _this44;
    _classCallCheck(this, PendantCategoryTabs);
    _this44 = _super19.call(this);

    // Get all tab buttons and panels
    _this44.tabButtons = _this44.querySelectorAll('.measuring-guide-tabs__button--pendant');
    _this44.tabPanels = _this44.querySelectorAll('.measuring-guide-tabs__panel--pendant');

    // Initialize the component
    _this44.init();
    return _this44;
  }

  /**
   * Initialize the tabs functionality
   */
  _createClass(PendantCategoryTabs, [{
    key: "init",
    value: function init() {
      var _this45 = this;
      if (this.tabButtons.length === 0 || this.tabPanels.length === 0) {
        return;
      }

      // Add click event listeners to each tab button
      this.tabButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var tabId = button.getAttribute('data-measuring-tab');
          _this45.activateTab(tabId);
        });

        // Add keyboard support
        button.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            _this45.navigateWithArrows(event.key, button);
          } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            var tabId = button.getAttribute('data-measuring-tab');
            _this45.activateTab(tabId);
          }
        });
      });

      // Set initial active state (first tab should be active)
      var firstTab = this.tabButtons[0];
      if (firstTab) {
        var firstTabId = firstTab.getAttribute('data-measuring-tab');
        this.activateTab(firstTabId);
      }
    }

    /**
     * Activate a specific tab
     * @param {string} tabId - The ID of the tab to activate
     */
  }, {
    key: "activateTab",
    value: function activateTab(tabId) {
      // Remove active state from all buttons and panels
      this.tabButtons.forEach(function (button) {
        button.classList.remove('measuring-guide-tabs__button--active');
        button.setAttribute('aria-selected', 'false');
      });
      this.tabPanels.forEach(function (panel) {
        panel.classList.remove('measuring-guide-tabs__panel--active');
        panel.setAttribute('hidden', '');
      });

      // Add active state to selected button and panel
      var activeButton = this.querySelector("[data-measuring-tab=\"".concat(tabId, "\"]"));
      var activePanel = this.querySelector("[data-measuring-panel=\"".concat(tabId, "\"]"));
      if (activeButton) {
        activeButton.classList.add('measuring-guide-tabs__button--active');
        activeButton.setAttribute('aria-selected', 'true');
      }
      if (activePanel) {
        activePanel.classList.add('measuring-guide-tabs__panel--active');
        activePanel.removeAttribute('hidden');
      }

      // Store current active tab
      this.activeTabId = tabId;

      // Initialize chain size chart for the active category
      this.initializeCategoryChart(tabId);
    }

    /**
     * Initialize chain size chart for a specific category
     * @param {string} categoryId - The category ID (thin, average, broad)
     */
  }, {
    key: "initializeCategoryChart",
    value: function initializeCategoryChart(categoryId) {
      var _this46 = this;
      setTimeout(function () {
        var chartContainer = _this46.querySelector("#".concat(categoryId, "-chain-size-chart-container"));
        if (chartContainer && window.ChainSizeChart) {
          var propertyName = "".concat(categoryId, "ChainSizeChart");
          if (!_this46[propertyName]) {
            _this46[propertyName] = new window.ChainSizeChart(chartContainer);
          }
        }
      }, 100);
    }

    /**
     * Handle arrow key navigation
     * @param {string} key - The key that was pressed
     * @param {HTMLElement} currentButton - Current focused button
     */
  }, {
    key: "navigateWithArrows",
    value: function navigateWithArrows(key, currentButton) {
      var currentIndex = Array.from(this.tabButtons).indexOf(currentButton);
      var newIndex;
      if (key === 'ArrowRight') {
        newIndex = (currentIndex + 1) % this.tabButtons.length;
      } else if (key === 'ArrowLeft') {
        newIndex = (currentIndex - 1 + this.tabButtons.length) % this.tabButtons.length;
      }
      if (newIndex !== undefined) {
        var newButton = this.tabButtons[newIndex];
        var newTabId = newButton.getAttribute('data-measuring-tab');
        this.activateTab(newTabId);
        newButton.focus();
      }
    }

    /**
     * Get the currently active tab ID
     * @returns {string} Active tab ID
     */
  }, {
    key: "getActiveTabId",
    value: function getActiveTabId() {
      var _this$tabButtons$5;
      return this.activeTabId || ((_this$tabButtons$5 = this.tabButtons[0]) === null || _this$tabButtons$5 === void 0 ? void 0 : _this$tabButtons$5.getAttribute('data-measuring-tab')) || '';
    }
  }]);
  return PendantCategoryTabs;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the pendant category tabs custom element
if (!customElements.get('pendant-category-tabs')) {
  customElements.define('pendant-category-tabs', PendantCategoryTabs);
}

// Helper function to open bracelet size chart drawer from anywhere
window.openBraceletSizeChartDrawer = function (triggerElement, productHandle) {
  var drawer = document.querySelector('#BraceletSizeChartDrawer');
  if (drawer) {
    drawer.show(productHandle || '');
  }
};

/**
 * Chain Unit Switcher Web Component
 * A reusable component that can be wrapped around any chain size chart content 
 * to add unit switching functionality
 */
var ChainUnitSwitcher = /*#__PURE__*/function (_HTMLElement20) {
  _inherits(ChainUnitSwitcher, _HTMLElement20);
  var _super20 = _createSuper(ChainUnitSwitcher);
  function ChainUnitSwitcher() {
    var _this47;
    _classCallCheck(this, ChainUnitSwitcher);
    _this47 = _super20.call(this);
    _this47.currentUnit = 'cm';
    _this47.init();
    return _this47;
  }
  _createClass(ChainUnitSwitcher, [{
    key: "init",
    value: function init() {
      this.setupEventListeners();
      this.updateInitialState();
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this48 = this;
      // Unit toggle buttons
      var unitButtons = this.querySelectorAll('[data-unit]');
      unitButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          var unit = e.target.getAttribute('data-unit');
          if (unit !== _this48.currentUnit) {
            _this48.currentUnit = unit;
            _this48.updateUnits();
          }
        });
      });
    }
  }, {
    key: "updateInitialState",
    value: function updateInitialState() {
      var _this49 = this;
      // Set initial active state for CM button
      var unitButtons = this.querySelectorAll('[data-unit]');
      unitButtons.forEach(function (btn) {
        btn.classList.remove('active');
        if (btn.getAttribute('data-unit') === _this49.currentUnit) {
          btn.classList.add('active');
        }
      });
    }
  }, {
    key: "updateUnits",
    value: function updateUnits() {
      var _this50 = this;
      // Update unit toggle buttons
      var unitButtons = this.querySelectorAll('[data-unit]');
      unitButtons.forEach(function (btn) {
        btn.classList.remove('active');
        if (btn.getAttribute('data-unit') === _this50.currentUnit) {
          btn.classList.add('active');
        }
      });

      // Update unit label displays
      var unitLabels = this.querySelectorAll('[data-unit-label]');
      unitLabels.forEach(function (label) {
        label.textContent = _this50.currentUnit.toUpperCase();
      });

      // Update measurements based on data attributes
      var measurements = this.querySelectorAll('.size-chart-measurement');
      measurements.forEach(function (measurement) {
        // Check for different data attribute patterns
        var cmValue = measurement.getAttribute('data-cm');
        var inchValue = measurement.getAttribute('data-inch');
        var mmValue = measurement.getAttribute('data-mm');
        if (cmValue && inchValue) {
          // Pattern: data-cm and data-inch
          if (_this50.currentUnit === 'cm') {
            measurement.textContent = cmValue;
          } else {
            measurement.textContent = inchValue;
          }
        } else if (mmValue && inchValue) {
          // Pattern: data-mm and data-inch (like ring size chart)
          if (_this50.currentUnit === 'cm') {
            // Convert mm to cm for display
            var cmDisplay = (parseFloat(mmValue) / 10).toFixed(1);
            measurement.textContent = cmDisplay;
          } else {
            measurement.textContent = inchValue;
          }
        }

        // Handle range format with separate spans
        var rangeSpan = measurement.querySelector('.measurement-range');
        var unitSpan = measurement.querySelector('.measurement-unit');
        if (rangeSpan && unitSpan) {
          var cmRange = measurement.getAttribute('data-cm-range');
          var inchRange = measurement.getAttribute('data-inch-range');
          if (_this50.currentUnit === 'cm' && cmRange) {
            rangeSpan.textContent = cmRange;
            unitSpan.textContent = 'cm';
          } else if (_this50.currentUnit === 'inch' && inchRange) {
            rangeSpan.textContent = inchRange;
            unitSpan.textContent = 'inch';
          }
        }
      });

      // Dispatch custom event for other components to listen to
      this.dispatchEvent(new CustomEvent('unitChanged', {
        detail: {
          unit: this.currentUnit,
          element: this
        },
        bubbles: true
      }));
    }

    // Public method to get current unit
  }, {
    key: "getCurrentUnit",
    value: function getCurrentUnit() {
      return this.currentUnit;
    }

    // Public method to set unit programmatically
  }, {
    key: "setUnit",
    value: function setUnit(unit) {
      if (unit !== this.currentUnit) {
        this.currentUnit = unit;
        this.updateUnits();
      }
    }
  }]);
  return ChainUnitSwitcher;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the chain unit switcher web component
if (!customElements.get('chain-unit-switcher')) {
  customElements.define('chain-unit-switcher', ChainUnitSwitcher);
}

// Helper function to open chain size chart drawer from anywhere
window.openChainSizeChartDrawer = function (triggerElement, productHandle) {
  var drawer = document.querySelector('#ChainSizeChartDrawer');
  if (drawer) {
    drawer.show(productHandle || '');
  }
};

/**
 * Pendant Size Chart Drawer Custom Element
 * Handles the pendant size chart drawer functionality
 */
var PendantSizeChartDrawer = /*#__PURE__*/function (_HTMLElement21) {
  _inherits(PendantSizeChartDrawer, _HTMLElement21);
  var _super21 = _createSuper(PendantSizeChartDrawer);
  function PendantSizeChartDrawer() {
    var _this51;
    _classCallCheck(this, PendantSizeChartDrawer);
    _this51 = _super21.call(this);
    _this51.addEventListener('keyup', function (evt) {
      return evt.code === 'Escape' && _this51.close();
    });
    _this51.querySelector('#PendantSizeChartDrawer-Overlay').addEventListener('click', _this51.close.bind(_assertThisInitialized(_this51)));

    // Initialize elements
    _this51.elements = {
      chartContent: _this51.querySelector('.pendant-size-chart-drawer__chart-content')
    };

    // Set up event listeners
    _this51.setupEventListeners();
    return _this51;
  }
  _createClass(PendantSizeChartDrawer, [{
    key: "setupEventListeners",
    value: function setupEventListeners() {
      // Add any additional event listeners here
    }
  }, {
    key: "open",
    value: function open() {
      var _this52 = this;
      this.openedBy = document.activeElement;
      this.setAttribute('open', '');
      if (this.classList.contains('animate')) {
        this.addEventListener('transitionend', function () {
          var elementToFocus = _this52.querySelector('[autofocus]') || _this52;
          elementToFocus.focus();
          _this52.trapFocus(_this52);
        }, {
          once: true
        });
      }
      document.body.classList.add('overflow-hidden');
    }
  }, {
    key: "close",
    value: function close() {
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      if (this.openedBy) {
        this.openedBy.focus();
      }
    }
  }, {
    key: "show",
    value: function show(productHandle) {
      // Product-specific logic can be added here
      this.productHandle = productHandle;
      this.open();

      // Initialize pendant size chart when drawer opens
      this.initializePendantSizeChart();
    }
  }, {
    key: "initializePendantSizeChart",
    value: function initializePendantSizeChart() {
      var _this53 = this;
      // Wait a bit for the drawer to be fully visible
      setTimeout(function () {
        var pendantChartContainers = _this53.querySelectorAll('[id*="pendant-size-chart-container"]');
        pendantChartContainers.forEach(function (container) {
          if (container && typeof window.PendantSizeChart !== 'undefined') {
            new window.PendantSizeChart(container);
          }
        });
      }, 100);
    }

    // Focus trap functionality (same as other drawers)
  }, {
    key: "trapFocus",
    value: function trapFocus(container) {
      var _this54 = this;
      var elementToFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : container;
      var elements = this.getFocusableElements(container);
      var first = elements[0];
      var last = elements[elements.length - 1];
      this.removeTrapFocus();
      this._handleFocusIn = function (event) {
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener('keydown', _this54._handleKeyDown);
      };
      this._handleFocusOut = function (event) {
        document.removeEventListener('keydown', this._handleKeyDown);
      };
      this._handleKeyDown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // If tab key is pressed, move focus to appropriate element
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          last.focus();
        }
      };
      document.addEventListener('focusout', this._handleFocusOut);
      document.addEventListener('focusin', this._handleFocusIn);
      elementToFocus.focus();
    }

    // Try to remove the trap focus
  }, {
    key: "removeTrapFocus",
    value: function removeTrapFocus() {
      var elementToFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      document.removeEventListener('focusin', this._handleFocusIn);
      document.removeEventListener('focusout', this._handleFocusOut);
      document.removeEventListener('keydown', this._handleKeyDown);
      if (elementToFocus) elementToFocus.focus();
    }

    // Find all focusable elements inside a container
  }, {
    key: "getFocusableElements",
    value: function getFocusableElements(container) {
      return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
    }
  }]);
  return PendantSizeChartDrawer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the pendant size chart drawer custom element
if (!customElements.get('pendant-size-chart-drawer')) {
  customElements.define('pendant-size-chart-drawer', PendantSizeChartDrawer);
}

/**
 * Pendant Size Chart Tabs Custom Element
 * Handles the tabbed navigation within the pendant size chart drawer
 */
var PendantSizeChartTabs = /*#__PURE__*/function (_HTMLElement22) {
  _inherits(PendantSizeChartTabs, _HTMLElement22);
  var _super22 = _createSuper(PendantSizeChartTabs);
  function PendantSizeChartTabs() {
    var _this55;
    _classCallCheck(this, PendantSizeChartTabs);
    _this55 = _super22.call(this);
    _this55.tabButtons = _this55.querySelectorAll('.size-chart-tabs__button');
    _this55.tabPanels = _this55.querySelectorAll('.size-chart-tabs__panel');
    _this55.init();
    return _this55;
  }

  /**
   * Initialize the tabs functionality
   */
  _createClass(PendantSizeChartTabs, [{
    key: "init",
    value: function init() {
      var _this56 = this;
      if (this.tabButtons.length === 0 || this.tabPanels.length === 0) {
        return;
      }

      // Add click event listeners to each tab button
      this.tabButtons.forEach(function (button, index) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          var tabId = button.dataset.tab;
          _this56.activateTab(tabId);
        });
        button.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            e.preventDefault();
            _this56.navigateWithArrows(e.key, button);
          }
        });
      });

      // Set initial active state (first tab should be active)
      var activeButton = this.querySelector('.size-chart-tabs__button--active');
      if (activeButton) {
        this.activateTab(activeButton.dataset.tab);
      }
    }

    /**
     * Activate a specific tab
     * @param {string} tabId - The ID of the tab to activate
     */
  }, {
    key: "activateTab",
    value: function activateTab(tabId) {
      // Remove active state from all buttons and panels
      this.tabButtons.forEach(function (button) {
        button.classList.remove('size-chart-tabs__button--active');
        button.setAttribute('aria-selected', 'false');
      });
      this.tabPanels.forEach(function (panel) {
        panel.classList.remove('size-chart-tabs__panel--active');
      });

      // Add active state to selected button and panel
      var activeButton = this.querySelector("[data-tab=\"".concat(tabId, "\"]"));
      var activePanel = this.querySelector("[data-panel=\"".concat(tabId, "\"]"));
      if (activeButton && activePanel) {
        activeButton.classList.add('size-chart-tabs__button--active');
        activeButton.setAttribute('aria-selected', 'true');
        activePanel.classList.add('size-chart-tabs__panel--active');
      }

      // Store current active tab
      this.activeTabId = tabId;
    }

    /**
     * Handle arrow key navigation
     * @param {string} key - The key that was pressed
     * @param {HTMLElement} currentButton - Current focused button
     */
  }, {
    key: "navigateWithArrows",
    value: function navigateWithArrows(key, currentButton) {
      var buttons = Array.from(this.tabButtons);
      var currentIndex = buttons.indexOf(currentButton);
      var newIndex;
      if (key === 'ArrowRight') {
        newIndex = currentIndex === buttons.length - 1 ? 0 : currentIndex + 1;
      } else {
        newIndex = currentIndex === 0 ? buttons.length - 1 : currentIndex - 1;
      }
      if (buttons[newIndex]) {
        buttons[newIndex].focus();
        this.activateTab(buttons[newIndex].dataset.tab);
      }
    }

    /**
     * Get the currently active tab ID
     * @returns {string} Active tab ID
     */
  }, {
    key: "getActiveTabId",
    value: function getActiveTabId() {
      return this.activeTabId || 'chart';
    }
  }]);
  return PendantSizeChartTabs;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the pendant size chart tabs custom element
if (!customElements.get('pendant-size-chart-tabs')) {
  customElements.define('pendant-size-chart-tabs', PendantSizeChartTabs);
}

/**
 * Pendant Size Chart Manager
 * Handles interactions for the pendant size chart including unit switching
 */
var PendantSizeChart = /*#__PURE__*/function () {
  function PendantSizeChart(container) {
    _classCallCheck(this, PendantSizeChart);
    this.container = container;
    this.currentUnit = 'cm';
    this.init();
  }
  _createClass(PendantSizeChart, [{
    key: "init",
    value: function init() {
      this.setupEventListeners();
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this57 = this;
      // Unit toggle buttons
      var unitButtons = this.container.querySelectorAll('.size-chart-unit-btn');
      unitButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          _this57.currentUnit = button.dataset.unit;
          _this57.updateUnits();
        });
      });
    }
  }, {
    key: "updateUnits",
    value: function updateUnits() {
      var _this58 = this;
      var unitButtons = this.container.querySelectorAll('.size-chart-unit-btn');
      var unitLabel = this.container.querySelector('[data-unit-label]');
      var sizeRows = this.container.querySelectorAll('.size-chart-row');

      // Update button states
      unitButtons.forEach(function (button) {
        button.classList.toggle('active', button.dataset.unit === _this58.currentUnit);
      });

      // Update unit label
      if (unitLabel) {
        unitLabel.textContent = this.currentUnit.toUpperCase();
      }

      // Update measurements
      sizeRows.forEach(function (row) {
        var measurement = row.querySelector('.size-chart-measurement');
        if (measurement) {
          var cmValue = measurement.dataset.cm;
          var inchValue = measurement.dataset.inch;
          if (_this58.currentUnit === 'cm' && cmValue) {
            measurement.textContent = cmValue;
          } else if (_this58.currentUnit === 'inch' && inchValue) {
            measurement.textContent = inchValue;
          }
        }
      });

      // Dispatch custom event for unit change
      this.container.dispatchEvent(new CustomEvent('unitChanged', {
        detail: {
          unit: this.currentUnit
        },
        bubbles: true
      }));
    }
  }]);
  return PendantSizeChart;
}(); // Export for use in other files
if (typeof window !== 'undefined') {
  window.PendantSizeChart = PendantSizeChart;
}

// Helper function to open pendant size chart drawer from anywhere
window.openPendantSizeChartDrawer = function (triggerElement, productHandle) {
  var drawer = document.querySelector('#PendantSizeChartDrawer');
  if (drawer) {
    drawer.show(productHandle || '');
  }
};

/**
 * Shirts Size Chart Drawer Custom Element
 * Handles the shirts size chart drawer functionality
 */
var ShirtsSizeChartDrawer = /*#__PURE__*/function (_HTMLElement23) {
  _inherits(ShirtsSizeChartDrawer, _HTMLElement23);
  var _super23 = _createSuper(ShirtsSizeChartDrawer);
  function ShirtsSizeChartDrawer() {
    var _this59;
    _classCallCheck(this, ShirtsSizeChartDrawer);
    _this59 = _super23.call(this);
    _this59.addEventListener('keyup', function (evt) {
      return evt.code === 'Escape' && _this59.close();
    });
    _this59.querySelector('#ShirtsSizeChartDrawer-Overlay').addEventListener('click', _this59.close.bind(_assertThisInitialized(_this59)));

    // Initialize elements
    _this59.elements = {
      chartContent: _this59.querySelector('.shirts-size-chart-drawer__chart-content')
    };

    // Set up event listeners
    _this59.setupEventListeners();
    return _this59;
  }
  _createClass(ShirtsSizeChartDrawer, [{
    key: "setupEventListeners",
    value: function setupEventListeners() {
      // Add any additional event listeners here
    }
  }, {
    key: "open",
    value: function open() {
      var _this60 = this;
      this.openedBy = document.activeElement;
      this.setAttribute('open', '');
      if (this.classList.contains('animate')) {
        this.addEventListener('transitionend', function () {
          var containerToTrapFocusOn = _this60.querySelector('.drawer__inner');
          var focusElement = _this60.querySelector('.drawer__close');
          _this60.trapFocus(containerToTrapFocusOn, focusElement);
        }, {
          once: true
        });
      }
      document.body.classList.add('overflow-hidden');
    }
  }, {
    key: "close",
    value: function close() {
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      if (this.openedBy) {
        this.removeTrapFocus(this.openedBy);
        this.openedBy = null;
      }
    }
  }, {
    key: "show",
    value: function show(productHandle) {
      // Product-specific logic can be added here
      this.productHandle = productHandle;
      this.open();

      // Initialize shirts size chart when drawer opens
      this.initializeShirtsSizeChart();
    }
  }, {
    key: "initializeShirtsSizeChart",
    value: function initializeShirtsSizeChart() {
      var _this61 = this;
      // Wait a bit for the drawer to be fully visible
      setTimeout(function () {
        var chartContainer = _this61.querySelector('#shirts-size-chart-container');
        if (chartContainer && window.ShirtsSizeChart && !_this61.shirtsSizeChart) {
          _this61.shirtsSizeChart = new window.ShirtsSizeChart(chartContainer);

          // Listen for size selection events
          chartContainer.addEventListener('sizeSelected', function (event) {
            console.log('Shirts size selected:', event.detail);
            // You can add custom logic here when a size is selected
          });
        }
      }, 100);
    }

    // Focus trap functionality (same as other drawers)
  }, {
    key: "trapFocus",
    value: function trapFocus(container) {
      var _this62 = this;
      var elementToFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : container;
      var elements = this.getFocusableElements(container);
      var first = elements[0];
      var last = elements[elements.length - 1];
      this.removeTrapFocus();
      this.trapFocusHandlers = this.trapFocusHandlers || {};
      this.trapFocusHandlers.focusin = function (event) {
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener('keydown', _this62.trapFocusHandlers.keydown);
      };
      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', _this62.trapFocusHandlers.keydown);
      };
      this.trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key

        // If tab key is pressed
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }

        //  If shift + tab keys are pressed
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          last.focus();
        }
      };
      document.addEventListener('focusout', this.trapFocusHandlers.focusout);
      document.addEventListener('focusin', this.trapFocusHandlers.focusin);
      elementToFocus.focus();
    }

    // Try to remove the trap focus
  }, {
    key: "removeTrapFocus",
    value: function removeTrapFocus() {
      var elementToFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (this.trapFocusHandlers) {
        document.removeEventListener('focusin', this.trapFocusHandlers.focusin);
        document.removeEventListener('focusout', this.trapFocusHandlers.focusout);
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown);
      }
      if (elementToFocus) elementToFocus.focus();
    }

    // Find all focusable elements inside a container
  }, {
    key: "getFocusableElements",
    value: function getFocusableElements(container) {
      return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
    }
  }]);
  return ShirtsSizeChartDrawer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the shirts size chart drawer custom element
if (!customElements.get('shirts-size-chart-drawer')) {
  customElements.define('shirts-size-chart-drawer', ShirtsSizeChartDrawer);
}

/**
 * Shirts Size Chart Manager
 * Handles interactions for the shirts size chart including unit switching
 */
var ShirtsSizeChart = /*#__PURE__*/function () {
  function ShirtsSizeChart(container) {
    _classCallCheck(this, ShirtsSizeChart);
    this.container = container.closest('.size-chart-chart-content');
    this.currentRegion = 'US';
    this.currentUnit = 'cm';
    this.init();
  }
  _createClass(ShirtsSizeChart, [{
    key: "init",
    value: function init() {
      this.setupEventListeners();
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this63 = this;
      // Unit toggle buttons - look for specific shirts size chart buttons
      var unitButtons = this.container.querySelectorAll('.size-chart-unit-btn[data-unit]');
      console.log('Shirts Size Chart: Found', unitButtons.length, 'unit buttons');
      unitButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          var unit = e.target.getAttribute('data-unit');
          console.log('Shirts Size Chart: Unit button clicked:', unit);
          if (unit !== _this63.currentUnit) {
            _this63.currentUnit = unit;
            _this63.updateUnits();
          }
        });
      });

      // Region selector (if needed in the future)
      var regionSelect = this.container.querySelector('[data-region-select]');
      if (regionSelect) {
        regionSelect.addEventListener('change', function (e) {
          _this63.currentRegion = e.target.value;
          _this63.updateRegion();
        });
      }
    }
  }, {
    key: "updateUnits",
    value: function updateUnits() {
      var _this64 = this;
      console.log('Shirts Size Chart: Updating units to', this.currentUnit);

      // Update unit toggle buttons
      var unitButtons = this.container.querySelectorAll('.size-chart-unit-btn[data-unit]');
      unitButtons.forEach(function (btn) {
        btn.classList.remove('active');
        if (btn.getAttribute('data-unit') === _this64.currentUnit) {
          btn.classList.add('active');
        }
      });

      // Update all measurement displays with ranges and units for the 4-column structure
      var rows = this.container.querySelectorAll('.size-chart-row');
      console.log('Shirts Size Chart: Found', rows.length, 'rows to update');
      rows.forEach(function (row) {
        var measurements = row.querySelectorAll('.size-chart-measurement');
        measurements.forEach(function (measurement, index) {
          var rangeSpan = measurement.querySelector('.measurement-range');
          var unitSpan = measurement.querySelector('.measurement-unit');
          if (rangeSpan && unitSpan) {
            var cmRange, inchRange;

            // Get the correct data attributes based on measurement column
            if (index === 0) {
              // Chest column
              cmRange = row.getAttribute('data-chest-cm');
              inchRange = row.getAttribute('data-chest-inch');
            } else if (index === 1) {
              // Waist column  
              cmRange = row.getAttribute('data-waist-cm');
              inchRange = row.getAttribute('data-waist-inch');
            } else if (index === 2) {
              // Neck column
              cmRange = row.getAttribute('data-neck-cm');
              inchRange = row.getAttribute('data-neck-inch');
            }
            if (_this64.currentUnit === 'cm') {
              rangeSpan.textContent = cmRange;
              unitSpan.textContent = 'cm';
            } else {
              rangeSpan.textContent = inchRange;
              unitSpan.textContent = 'inch';
            }
          }
        });
      });
    }
  }, {
    key: "updateRegion",
    value: function updateRegion() {
      // Update region label
      var regionLabel = this.container.querySelector('[data-current-region]');
      if (regionLabel) {
        regionLabel.textContent = this.currentRegion;
      }

      // Hide all rows
      var allRows = this.container.querySelectorAll('.size-chart-row');
      allRows.forEach(function (row) {
        row.style.display = 'none';
      });

      // Show rows for current region
      var currentRegionRows = this.container.querySelectorAll("[data-region=\"".concat(this.currentRegion, "\"]"));
      currentRegionRows.forEach(function (row) {
        row.style.display = 'flex';
      });
    }
  }]);
  return ShirtsSizeChart;
}(); // Export for use in other files
if (typeof window !== 'undefined') {
  window.ShirtsSizeChart = ShirtsSizeChart;
}

// Helper function to open shirts size chart drawer from anywhere
window.openShirtsSizeChartDrawer = function (triggerElement, productHandle) {
  var drawer = document.querySelector('#ShirtsSizeChartDrawer');
  if (drawer) {
    drawer.show(productHandle || '');
  }
};

// Export for potential use in other modules
if ( true && module.exports) {
  module.exports = {
    MenuCategories: MenuCategories,
    SizeChartDrawer: SizeChartDrawer,
    SizeChartTabs: SizeChartTabs,
    MeasuringGuideTabs: MeasuringGuideTabs,
    BraceletSizeChart: BraceletSizeChart,
    BraceletSizeChartDrawer: BraceletSizeChartDrawer,
    BraceletSizeChartTabs: BraceletSizeChartTabs,
    BraceletMeasuringGuideTabs: BraceletMeasuringGuideTabs,
    ChainSizeChart: ChainSizeChart,
    ChainSizeChartDrawer: ChainSizeChartDrawer,
    ChainSizeChartTabs: ChainSizeChartTabs,
    ChainCategoryTabs: ChainCategoryTabs,
    ChainUnitSwitcher: ChainUnitSwitcher,
    PendantSizeChart: PendantSizeChart,
    PendantSizeChartDrawer: PendantSizeChartDrawer,
    PendantSizeChartTabs: PendantSizeChartTabs,
    PendantCategoryTabs: PendantCategoryTabs,
    ShirtsSizeChart: ShirtsSizeChart,
    ShirtsSizeChartDrawer: ShirtsSizeChartDrawer
  };
}

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/main": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkhandee"] = self["webpackChunkhandee"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/scss/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;